import { render, staticRenderFns } from "./OTForm.vue?vue&type=template&id=b70c09c4&scoped=true&lang=pug"
import script from "./OTForm.vue?vue&type=script&lang=js"
export * from "./OTForm.vue?vue&type=script&lang=js"
import style0 from "./OTForm.vue?vue&type=style&index=0&id=b70c09c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b70c09c4",
  null
  
)

export default component.exports